export default __webpack_public_path__ + "static/media/Mark-2-HUD-07.f82c148d.jpg";